"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var swr_hooks_2 = require("@l2p/swr-hooks");
var Copyright = function (_a) {
    var restrictedLicenseCountries = _a.restrictedLicenseCountries, License = _a.License;
    var getTexts = (0, swr_hooks_1.useTexts)(swr_hooks_2.TEXT_CATEGORIES.LICENSE);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.wrapper },
        License ? (react_1.default.createElement(License, null)) : (getTexts(swr_hooks_2.TEXT_KEYS.FOOTER_LICENSE, {
            year: new Date().getFullYear(),
        })),
        ' '));
};
exports.default = Copyright;
